import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IAccountDataTableRowFormMeta {
  currency: FormInputMeta,
  hpxAccount: FormInputMeta,
  account: FormInputMeta,
  //
  schema: any,
}

const AccountDataTableRowFormMeta = {} as IAccountDataTableRowFormMeta;

AccountDataTableRowFormMeta.currency = {
  name: "currency",
  label: "Devise",
  type: "select",
  options:  [
      {
        label: 'Devise A',
        value: 'a'
      },
      {
        label: 'Devise B',
        value: 'b',
      },
      {
        label: 'Devise C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
};
AccountDataTableRowFormMeta.hpxAccount = {
  name: 'hpxAccount',
  type: 'text',
  label: 'Compte HPX',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
AccountDataTableRowFormMeta.account = {
  name: 'account',
  type: 'text',
  label: 'Compte',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};

AccountDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(AccountDataTableRowFormMeta));

export default AccountDataTableRowFormMeta;
